import React, { useEffect, useState } from 'react';
import { usePagination, DOTS } from '../../Hooks/usePagination';
import Prev from '../../Assets/Pagination/Prev.svg';
import Next from '../../Assets/Pagination/Next.svg';
import ChevronDown from '../../Assets/Pagination/ChevronDown.svg'

const Pagination = (props) => {
    const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
        onSizeSelect,
    } = props;

    const [isOpen, setIsOpen] = useState(false);
    const [dropdownList, setDropdownList] = useState([]);

    const generateListOfNumbers = (length) => {
        const maxNumber = 50;
        let lastNumber;
        if (length <= maxNumber) {
            if(length > 30 && length <= 40) {
                lastNumber = 30;
            }
            else if(length > 20 && length <= 30) {
                lastNumber = 20;
            }
            else if(length > 10 && length <= 20) {
                lastNumber = 10;
            }
            else {
                lastNumber = length - (10 - maxNumber % length);
            }
        } else {
            lastNumber = maxNumber;
        }
        const numbersArray = Array.from({ length: lastNumber/10 }, (_, index) => (index + 1) * 10);
        return numbersArray.map(number => Math.min(number, lastNumber));
    };

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    const handleOptionClick = (size) => {
        onSizeSelect(size);
        if((currentPage - 1)*size + 1 > totalCount) {
            let nextPage = (totalCount - (totalCount%size))/size + 1;
            onPageChange(nextPage);
        }
        setIsOpen(false);
    };

    let lastPage = paginationRange[paginationRange.length - 1];

    useEffect(() => {
        if (totalCount > 0) {
            const generatedList = generateListOfNumbers(totalCount);
            setDropdownList(generatedList);
        }
    }, [totalCount]);

    if (currentPage === 0 || paginationRange.length < 2) {
        return null;
    }

    return (
        <div className="mt-5 mx-auto flex items-center gap-3">
            <ul className='flex gap-[5px] list-none'>
                <li
                    className={`p-[10px] gap-[10px] rounded-lg border border-[#F1F1F1] h-8 w-8 flex items-center justify-center cursor-pointer ${currentPage === 1 ? 'pointer-events-none' : ''}`}
                    onClick={onPrevious}
                >
                    <div className='h-4 w-4 flex items-center justify-center'>
                        <img className='bg-transparent select-none' src={Prev} alt="Prev" />
                    </div>
                </li>
                {paginationRange.map((pageNumber, index) => {
                    if (pageNumber === DOTS) {
                        return <li key={index} className="select-none font-sans p-[10px] gap-[10px] h-8 text-center text-[#333333] font-semibold flex items-center justify-center rounded-lg leading-[17.7px] text-[13px] min-w-8 border-none hover:bg-transparent hover:cursor-default">&#8230;</li>
                    }

                    return (
                        <li 
                            key={index} 
                            className={`select-none text-[#121212] p-[10px] gap-[10px] h-8 text-center font-semibold flex items-center justify-center rounded-lg leading-[15.6px] text-[13px] min-w-8 border border-[#F1F1F1] hover:cursor-pointer ${pageNumber === currentPage ? 'bg-primaryColor hover:bg-primaryAccent text-buttonText border-none' : 'hover:bg-[#0000000A]'}`}
                            onClick={() => onPageChange(pageNumber)}
                        >
                            {pageNumber}
                        </li>
                        );
                    })
                }
                <li
                    className={`p-[10px] gap-[10px] rounded-lg border border-[#F1F1F1] h-8 w-8 flex items-center justify-center cursor-pointer ${currentPage === lastPage ? 'pointer-events-none' : ''}`}
                    onClick={onNext}
                >
                    <div className='h-4 w-4 flex items-center justify-center'>
                        <img className='bg-transparent select-none' src={Next} alt="Next" />
                    </div>
                </li>
            </ul>

            <div className="flex items-center gap-[10px]">
                <h2 className='font-sans font-semibold text-[14px] leading-[19.07px] text-[#333333] select-none'>Result</h2>

                <div className='relative'>
                    <button className="select-none flex items-center gap-2 border border-[#DDDDDD] px-[15px] py-2 rounded-lg font-sans font-semibold text-[14px] leading-[19.07px]" onClick={() => setIsOpen(!isOpen)}>
                        {pageSize}

                        <span className='w-4 h-4 flex items-center justify-center'>
                            <img src={ChevronDown} alt="Chevron Down" />
                        </span>
                    </button>

                    {isOpen && (
                        <ul className="absolute w-[70px] font-sans font-semibold bottom-10 border border-[#DDDDDD] rounded-lg overflow-hidden">
                            {dropdownList.map((size, index) => {
                                return (
                                    <li 
                                        key={index} 
                                        className='select-none text-[#333333] text-[14px] leading-[19.07px] p-[8px_15px_8px_15px] bg-white hover:bg-[#F6F6F6] hover:cursor-pointer' onClick={() => handleOptionClick(size)}
                                    >
                                        {size}
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>

                <h2 className='font-sans font-semibold text-[14px] leading-[19.07px] text-[#333333] select-none'>of {totalCount}</h2>
            </div>
        </div>
    );
};

export default Pagination;
